import { useState, useEffect } from "@wordpress/element";
import { cn } from "@/lib/utils";
import { setPointerTrailColor } from "@/lib/feature-style";

const DEFAULT_COLORS = [
	"#3b82f6",
	"#ef4444",
	"#10b981",
	"#f59e0b",
	"#8b5cf6",
	"#ec4899",
	"#0ea5e9",
	"#14b8a6",
];

export default function PointerTrailColorPicker({ colors = DEFAULT_COLORS }) {
	const [current, setCurrent] = useState(() => {
		if (typeof localStorage !== "undefined") {
			return (
				localStorage.getItem("accessibility-widget-pointerTrail-color") ||
				colors[0]
			);
		}
		return colors[0];
	});

	useEffect(() => {
		const handler = (e) => {
			if (e.detail?.color) setCurrent(e.detail.color);
		};
		window.addEventListener("pointerTrail-color-changed", handler);
		return () =>
			window.removeEventListener("pointerTrail-color-changed", handler);
	}, []);

	return (
		<div
			className="zn:absolute zn:bottom-1.5 zn:flex zn:flex-wrap zn:gap-1 zn:justify-center "
			onClick={(e) => e.stopPropagation()}
			aria-label="Pointer trail colors"
			role="list"
		>
			{colors.map((color) => (
				<button
					key={color}
					type="button"
					role="listitem"
					aria-label={`Pointer trail color ${color}`}
					onClick={() => {
						setPointerTrailColor(color);
						setCurrent(color);
					}}
					className={cn(
						"zn:w-3 zn:h-3 zn:rounded-full  zn:transition zn:flex zn:items-center zn:justify-center ",
						{
							"zn:!border": current === color,
						},
					)}
					style={{ borderColor: current ? color : "transparent" }}
				>
					<span
						className="zn:h-2 zn:w-2 zn:flex zn:rounded-full"
						style={{ background: color }}
					></span>
				</button>
			))}
		</div>
	);
}
